import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme)=>({
    root: {
        display: 'flex',
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        overflowX: 'hidden',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        paddingLeft: theme.spacing(4),
    },
    paper: {  
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 385,
        overflowY: 'hidden',
        overflowX: 'hidden',
    },
    buttonCenter:{
        display: 'flex',
        justifyContent: 'center'
    }
}))